import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material';

type ItemStatusBtnProps = {
  isSelected?: boolean;
  selectedBgColor?: string;
  customWidth?: string;
  iconColor?: string;
  labelColor?: string;
};

export const ItemStatusBtn = styled(LoadingButton, {
  shouldForwardProp: (prop) =>
    prop !== 'isSelected' && prop !== 'selectedBgColor' && prop !== 'iconColor' && prop !== 'labelColor',
})<ItemStatusBtnProps>(({ theme, isSelected, selectedBgColor, labelColor, iconColor }) => ({
  padding: '4px 12px',
  borderColor: isSelected ? selectedBgColor : theme.palette.case.neutral.n100,
  fontSize: '12px',
  backgroundColor: isSelected ? selectedBgColor : 'transparent',
  fontWeight: '400',
  lineHeight: '24px',
  whiteSpace: 'nowrap',
  color: isSelected ? labelColor : theme.palette.case.neutral.n500,
  transition: 'all 0.3s',
  svg: {
    path: {
      transition: 'all 0.3s',
      fill: `${iconColor} !important`,
    },
  },

  [theme.breakpoints.down('sm')]: {
    padding: '4px 12px',
  },

  '&:hover': {
    backgroundColor: selectedBgColor,
    borderColor: selectedBgColor,
    color: labelColor,
    boxShadow: 'none',
  },

  '&: disabled': {
    borderColor: theme.palette.case.neutral.n400,
    backgroundColor: theme.palette.case.neutral.n400,
    color: theme.palette.case.contrast.white,
    svg: {
      path: {
        fill: theme.palette.case.contrast.white,
      },
    },
  },
}));
